module.exports = __webpack_public_path__ + "static/media/fly0217.5e488d00.webp";